import {Lightning} from "@lightningjs/sdk"
import { Base, TextBox } from "@lightningjs/ui-components"
import { Helper } from "../../../helper"
import EPGUtility from "../epg-utility"

export default class EPGTimelineUI extends Base {
    [x: string]: any

    static get __componentName(): string {
        return 'EPGTimelineUI'
    }

    static get tags() {
        return []
    }

    static get properties() {
        return ['startDate', 'index', 'channelIndex']
    }

    _update(){
        this.patch({
            Background1: {
                w:this.finalW,
                h:this.finalH,
                rect:true,
                color: 0x00000000,
                zIndex:1,
                children: [
                    {
                        zIndex:2,
                        type: TextBox,
                        fixed: true,
                        w:this.w,
                        content: EPGUtility.formatAMPM(this.st),
                        style: {
                            offsetY: 20,
                            textStyle: {
                                fontSize: 22,
                                fontFace: Helper.getFontFamily('Black'),
                                textColor: 0x99ffffff,
                                maxLines: 1,
                                maxLinesSuffix: '...'    
                            }
                        }
                    }
                ]
            }
        })
    }

    override getFocusScale() {
        return 1
    }
}
